import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/layout";
import HomePage from "./pages/home";
import SignUpPage from "./pages/signup";
import VerifyEmailPage from "./pages/verify";
import DashboardPage from "./pages/dashboard";
import LoginPage from "./pages/login";
import Contact from "./pages/contact";
import NotFoundPage from "./pages/notFound";
import ProtectedRoute from "./components/protectedRoutes";
import HowToUsePage from "./pages/howTo";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/howto" element={<HowToUsePage />} />
          <Route path="/verify/:token" element={<VerifyEmailPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Router>
  );
}
